var exports = {
  "kL": "x4c3adb35--b367e1--container",
  "Hw": "x4c3adb35--b367e1--mobile",
  "S3": "x4c3adb35--b367e1--content_container",
  "Um": "x4c3adb35--b367e1--text_wrapper",
};

module.exports = exports;
